import React from 'react';

const CloseIcon = ({ onClick }) => {
	return (
		<div className="text-right close-icon" onClick={onClick}>
			<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
				<path
					d="M18.5038 5.7107C18.1138 5.3207 17.4838 5.3207 17.0938 5.7107L12.2038 10.5907L7.31383 5.7007C6.92383 5.3107 6.29383 5.3107 5.90383 5.7007C5.51383 6.0907 5.51383 6.7207 5.90383 7.1107L10.7938 12.0007L5.90383 16.8907C5.51383 17.2807 5.51383 17.9107 5.90383 18.3007C6.29383 18.6907 6.92383 18.6907 7.31383 18.3007L12.2038 13.4107L17.0938 18.3007C17.4838 18.6907 18.1138 18.6907 18.5038 18.3007C18.8938 17.9107 18.8938 17.2807 18.5038 16.8907L13.6138 12.0007L18.5038 7.1107C18.8838 6.7307 18.8838 6.0907 18.5038 5.7107Z"
					fill="#6A7181"
				/>
			</svg>
		</div>
	);
};

export default CloseIcon;
